import IWizardStep from '../../../../interfaces/IWizardStep';
import WizardButton from '../../components/WizardButton';
import { WizardContent } from '../../components/WizardContent';
import { WizardSecodaryTitle } from '../../components/WizardSecodaryTitle';
import { WizardTitle } from '../../components/WizardTitle';

interface SuccessProps extends IWizardStep {}

const Success = (props: SuccessProps) => {
  const handleSubmit = async () => {
    props.setStep(2, { ...props.medicalCertificate });
  };

  return (
    <WizardContent style={{ backgroundColor: 'rgb(32, 120, 110)', height: '100%', color: '#fff' }}>
      <WizardTitle style={{ fontSize: '1.6rem' }}>O seu atestado foi enviado com sucesso!</WizardTitle>
      <WizardSecodaryTitle>
        Você receberá um e-mail e/ou whatsapp informando sobre o andamento do processo.
      </WizardSecodaryTitle>
      <br />
      <WizardSecodaryTitle>{`Número do Protocolo: ${props.medicalCertificate.protocolNumber}`}</WizardSecodaryTitle>
      <WizardButton onClick={handleSubmit} sx={{ marginTop: '60px' }}>
        Voltar ao início
      </WizardButton>
    </WizardContent>
  );
};

export default Success;
